module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EACE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian Smith drew a deep breath as she walked along the jagged cliff overlooking the stormy Pacific Ocean, relishing the fresh air, stunning scenery and a rare moment of freedom. Things were definitely looking up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t seen Vittorio’s men in over nine months and she was certain that if she was careful, they’d never find her here, in this small, private coastal town just a few miles outside Carmel, California.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For one, she didn’t use her name, Jillian Smith, anymore. She had a new identity, April Holliday, and a new look—blonde, tan, as if she were a California native instead of a striking brunette from Detroit. Not that Vitt knew she was from Detroit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nor could he know. It was imperative she keep Vittorio, the father of her baby, as far away from her as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was so dangerous. Such a threat. To her. To Joe. To everything she held dear. She’d loved him, had come so close to imagining a future with him, only to discover that he wasn’t a hero…wasn’t a knight in shining armor but a man like her father. A man who’d made his fortune in organized crime.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Jillian drew a short breath, aware of the tension balling in her shoulders. Relax, she told herself. There’s no reason to")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("be afraid. The danger’s behind you now. Vitt doesn’t know where you are. He can’t take the baby from you. You’re safe. Everything’s good.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She paused along the cliff to stare out at the dark blue water crested with foam. The waves were big today and they crashed against the dark rocks below with power and passion. The sea seemed angry, almost inconsolable, and for a moment she felt the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d loved Vitt. And maybe they’d been together only two weeks, but in those two weeks she’d imagined a life with him. Imagined so many possibilities for them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then the truth emerged. He wasn’t a hero—no prince on a white stallion—but a terrifying villain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first raindrops began to fall and she pushed back her long blond hair from her face, determined to put the past behind her and focus on the present as well as Joe’s future. And Joe would have a great future. She’d make sure he had everything she’d never known—stability, security, a happy home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Already she’d found a darling rental house just a quarter mile down the road on a quiet cul-de-sac. She’d gotten an amazing job at the Highlands Inn, one of the premier hotels on the Northern California coast, assisting with their marketing and sales. And best of all, she’d found excellent child care so she could work. In fact, lovely Hannah was with Joe now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain pelted down, and the brisk wind whipped at her hair, tugging at her black fisherman’s sweater, but she welcomed the fierce weather, and loved its intensity. She couldn’t help smiling at the ocean, and the endless horizon, imagining life’s possibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thinking of jumping, Jill?” A deep male voice spoke behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her smile vanished as she stiffened in shock, recognizing the smooth, accented voice immediately.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vittorio.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t heard his voice in nearly a year, but Vitt’s was impossible to forget. Deep and calm, his voice was pitched to dominate life—whether it be man or nature—and it did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then, Vittorio Marcello d’Severano was a force of nature, a human being that inspired awe or fear in virtually everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are solutions,” he added softly, so softly that Jillian shuddered, and took a nervous step away from him, putting her closer to the cliff’s edge. Her unsteady footstep sent loose rocks tumbling from the craggy point to the cove below. The falling rocks sounded like her heart shattering and Jill’s throat squeezed closed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just when she’d felt secure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just when she’d thought they were safe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unbelievable. Impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“None that I would find acceptable,” she answered flatly, turning slightly but avoiding looking him in the face. She knew better than to look at Vitt closely, much less meet his gaze. Vittorio was a magician, a virtual snake charmer. He could get anyone to do anything just by smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was that handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was that powerful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is that all you have to say to me after months of cat-and-mouse games?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain fell harder, drenching Jillian’s thick knit sweater so that it ran with rivulets of water. “I believe everything has already been said. I can’t think of anything I’ve forgotten,” she retorted, her chin tilted in defiance even though her legs shook beneath her. She was torn between fury and terror. Vittorio was just a man, and yet he could, and would, destroy her world given the chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And no one would stop him.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can. Let me suggest you begin with an apology,” he said almost gently. “It would be a start.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian threw back her shoulders and steeled herself against that deep, husky voice of his, forcing her gaze to his throat. What harm could there be in that? And yet it was impossible to look at his throat—strong and bronzed by sun—without seeing the square chin or the broad shoulders encased in charcoal-black.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And even limiting herself to that very narrow region, her stomach plummeted. Because Vittorio was still everything that overwhelmed her. Impossibly physical and primal, he was the true alpha male. No one was stronger. No one more powerful. She’d tumbled into his bed within hours of meeting him and she’d never done that before. For God’s sake, she’d never even come close to making love before but something about Vitt made her drop her guard. With him, she felt safe. Near him, she’d felt secure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If anyone ought to apologize, it should be you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You misrepresented yourself, Vittorio—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“—and you’ve hunted me like an animal for the past eleven months,” she said, her voice hard, her tone clipped. She would not fall to her knees. She would not beg. She would fight him to the bitter end.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. “You chose to run. You had my son. What else did you expect me to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It must thrill you to have such power over helpless women and children!” she flashed, raising her voice to be heard over the wind and the great angry walls of water crashing onto the beach below.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re far from helpless, Jill. You’re one of the strongest, shrewdest women I’ve ever met, with the skills of a professional con artist.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not a con artist.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why the alias of April Holliday? And how did you manage to create such a persona? It takes money and connections to pull off what you nearly pulled off—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nearly.")]), _vm._v(" That is the key word, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged again. “That’s for another discussion. Right now I’d like to get out of the rain—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re free to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going nowhere without you. And I don’t like you standing so close to the edge of the cliff. Come away. You worry me,” he said, extending a hand to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She ignored his hand, and glanced up instead, her gaze taking in the long, lean jaw, the angled cheekbone, the very sensual lips above his firm chin, and all it took was that one glance for her to go hot, then cold, and hot all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you terrify me,” she answered bitterly, looking swiftly away, knowing that his lips had kissed her everywhere, exploring her body with mind-blowing detail. He’d brought her to her first orgasm with his mouth and tongue and she’d been mortified when she’d screamed as she came. She hadn’t imagined pleasure so intense or sensation so strong. She’d never known anything could shatter her control. But then, she hadn’t ever imagined a man like Vittorio.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the truth was, she wasn’t terrified of him. She was terrified of herself when around him. Because in Bellagio, Vittorio undid her. With just one look, he weakened her resolve. One kiss, and he shattered her independence. From the first time they’d made love, she wanted him far too much, realizing she needed him more than she’d ever needed anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re ridiculous,” he chided, his tone exasperated. “Have I ever hurt you, or laid a hand on you—other than to pleasure you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("She closed her eyes as her legs wobbled beneath her. During their two weeks together, two incredible weeks, he had only")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("shown her kindness, and tenderness, and passion. Yes, he’d had his secrets. He’d been mysterious. But she’d ignored her concerns and followed her heart. “No.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you ran. And worse, you’ve kept my only child, my son, from me. How is that fair?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t answer because already his voice was doing that strange seduction, where he peeled away her rigid control, stripping away her defenses. He’d done it that very first day she’d met him in the hotel lobby in Istanbul. One introduction, one brief conversation, one invitation to dinner and then she lost her head completely. Took leave from her job. Moved into his villa at Lake Como. Imagined she was in love…something Jillian didn’t even believe in. Romantic love was silly and foolish and destructive. Romantic love was for other people, people who didn’t know better. She’d thought she knew better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then came Vitt, and there went sanity, reason, self-preservation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, he was too dangerous for words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d destroy her. And Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But no, she wouldn’t let him have Joe. Wouldn’t let Vitt turn Joe into a man like him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s not Sicilian, Vittorio. He’s American. And a baby and my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve indulged you this past year, given you time alone together, but now it’s my turn—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” Jillian pressed her nails into her palms, barely maintaining control. “You can’t have him, you can’t.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("She swayed on the lip of the cliff, aware that the rain was making the soil a soggy, unstable mess, but she’d never go to Vittorio, nor would she give in to him. Far better to tumble backward into space than let Vittorio have Joe. Because at least Joe was safe with Hannah. Hannah knew if anything happened to Jillian, she was to take Joe to Cynthia, her college")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("roommate in Bellevue, Washington. Cynthia had agreed to be Joe’s guardian should the need arise and Jillian had formal papers drawn, clearing the way for adoption. Because it was Jillian’s fervent wish that Joe be raised by a loving family. A normal family. A family with no ties to organized crime.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A family unlike her own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A family unlike Vittorio’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jill, give me your hand now. That ledge could give way any moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t care. Not if it means I can protect my son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Protect him from whom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v("? Protect him from what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The concerned note in his voice drew tears to her eyes and her heart lurched within her chest. It took all of her strength to harden herself against him. He’d fooled her once, but she wouldn’t be fooled again. She was smarter. She was older. And she was a mother now. Jillian wouldn’t be swayed by warmth or tenderness, seduction or pleasure. This was about Joe, and only about Joe. His safety. His survival. His future.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This could have been avoided if she’d only known who she was dealing with when she accepted Vitt’s dinner invitation twenty months ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she’d only understood the implications of that date.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she hadn’t. Instead she’d cast Vittorio as Prince Charming and put him on a white horse and believed he was going to save her. Or at the very least, take her to an extravagant, romantic dinner and make her feel like a princess for a night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The extravagant dinner turned into a fantasy romance. He made her feel so beautiful and desirable that she tumbled eagerly into his bed. He hadn’t disappointed. He’d been an incredible lover and even now she could remember how his body had felt against hers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("She remembered the warm satin of his skin stretched over dense, sinewy muscle. Remembered his lean narrow hips and")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("the black crisp hair low on his belly. Remembered the sensation of him extending her arms and holding her still as he slowly thrust into her and then even more slowly withdrew.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knew how to use his body. He knew a woman’s body. He’d quickly mastered hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For two blissful weeks she’d imagined she was falling in love with him, and fantasized about living with him, making a life with him, making a home. Yes, there were moments Vittorio was called away to take calls at strange hours, but she’d discounted those calls, telling herself it was just business, or the time difference, and that he was a CEO of a large international company so he had to work at all hours of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d told her about his company, too, and she was fascinated by his newest acquisition—the purchase of three venerable, five-star hotels in Eastern Europe—and she’d fantasized about leaving her hotel job in Turkey and going to work for Vitt, helping him overhaul his newest hotels. After all, hotel management was her area of expertise, and she imagined them traveling the world together, exploring, working, making love.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then on day fourteen, one of Vitt’s young housemaids shattered her illusions with the whispered question, “You’re not afraid of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mafioso")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mafioso.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The word chilled Jillian’s blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?” Jill asked, striving to sound casual as the maid’s eyes darted toward the bathroom door where Vittorio was showering. The maid was only there to bring fresh towels but apparently her curiosity had got the best of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your man,” the maid answered, handing off the stack of plush white towels. “Signor d’Severano.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He isn’t—”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sì.")]), _vm._v(" Everyone knows.” And then the maid disappeared, hurrying away like a frightened field mouse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then the pieces fell into place. Of course. It all added up. Why hadn’t she seen it before? Vittorio’s immense wealth. His lavish lifestyle. His strange, secretive phone calls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian had wanted to throw up. Instead she used her phone to do a quick internet search while Vittorio dressed and the d’Severano name pulled up pages and pages of links and stories and photos.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The maid had been right. Vittorio d’Severano, of Catania, Sicily, was a very famous man. Famous, for all the wrong reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian ran away that very afternoon, taking just her passport and purse and leaving everything else behind. Clothes, shoes, coats—they could all be replaced. But freedom? Safety? Sanity? Those could not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian gave up everything that day. She gave notice at the hotel, gave up her apartment, left Europe and all her friends, vanishing as if she’d never existed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew how to do that, too. It was something she’d learned at twelve when her family was taken into the American government’s Witness Protection Program. Since twelve she’d been an imposter of her former self.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian became Heather Purcell in Banff, Canada, and worked for four months as a hotel operator at the Fairmont Hotel at Lake Louise in the Canadian Rockies. It was there in Alberta, Canada that she’d discovered she was pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You had to know I’d eventually catch you,” he added kindly. “You had to know I’d win.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Trapped.")]), _vm._v(" The word rushed at her, just as the relentless waves crashed onto the sand. But she wasn’t a quitter. She was a fighter. And she wouldn’t give up. She’d learned through hard experience to be tough, and had been fighting like mad ever since she discovered she was pregnant to protect her child")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("from a life that would destroy him, because Jillian knew that life. Jillian’s father had once lived that life, dragging them all into hell with him.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain fell harder, slashes of cold wind and water that drenched, chilling her to the bone, but Vitt looked sleek and polished and unperturbed. But then, Vitt always looked sleek, and polished, and unperturbed. It’s what had drawn her to him in the beginning. That and his beautiful face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you haven’t won,” she said from between chattering teeth. “Because you don’t have him, and you can torture me, or kill me, or whatever it is you do to people, but I won’t ever tell you where he is—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why would I ever want to hurt you? You’re the mother of my son, my only child, and therefore precious to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know what I am to you. Dispensable. You made that more than clear eleven months ago when you sent your thugs after me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My men are hardly thugs, and you’ve turned me into an adversary, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v(", by keeping my son from me.” Vittorio’s voice momentarily hardened to match the set of his lean, hard jaw before easing again. “But I’m willing to put aside our differences for our son’s sake. So, please, come. I don’t like you standing so close to the edge. It’s not safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His dark gaze raked the cliff and her shivering, rain-soaked figure. “I suppose it depends on your definition. But I’m not interested in semantics. It’s time to get out of the cold.” And with a decisive step toward her, he shot out his hand, reaching for hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Jillian couldn’t, wouldn’t, let him touch her. Not now, not ever again. She leaned away, pulling back so violently that she lost her footing, crying out as she fell. Vittorio, blessed with quick reflexes, grabbed her wrist and held on tight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("For a split second she dangled in midair, nothing beneath ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("her but the beach and crashing waves, and then her fingers wrapped around his wrist and she squeezed tight.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could save her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He would, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vitt hauled her back up from over the edge, pulling her onto her feet and into his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shuddered as her body came into contact with his. Even wet, he was big and solid and overwhelming. So very overwhelming and she collapsed against him, needing, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("craving")]), _vm._v(" warmth and security and safety.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His arm wrapped around her tightly, holding her firmly against him. He felt good. Warm. Real.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment she imagined he might still possibly have feelings for her. For a moment she imagined that maybe they could find a way to raise Joe together, and then reality crashed into her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was she mad? Had she lost her senses completely?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no way they could be together, no way to raise Joe together. She could not allow Joe to be drawn into the d’Severano world, and yet as Vittorio’s oldest son, it’s what would be expected of him. And expected of Vitt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anguish and heartbreak beat at her. “I can’t do this, Vitt,” she choked, as he wrapped an arm around her waist, holding her steady against him. “I won’t be part of your life. I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slid his palm across her cheek, pushing heavy blond hair back from her cold face. His hand was warm, so warm, and the caress sent a shiver through her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what is so wrong about my life?” he asked, his voice pitched low.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment she could think of nothing. What could be wrong when Vitt held her so securely? How could feeling good be bad?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Her cheek tingled from his touch and her insides did crazy ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("flips. She struggled to put together a coherent sentence. “You know,” she whispered, thinking of her father, his ties to the Detroit mob and the terrible consequences for all of them, although no one had paid more dearly than her sister.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Explain it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t.” She trembled against him, acutely aware of every place his body pressed against hers. His chest against her breasts. His hips tight against her pelvis. His thighs against her thighs. The contact was both exquisite and excruciating. Her body loved it, him. Her body wanted so much more. Her mind, though, revolted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?” He stroked her hair over her shoulders into smooth wet waves down her back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She drew back to look into his eyes. It was a mistake, as her heart turned over. He was beautiful. Beyond beautiful. But also so very lethal. He could destroy her with the blink of his eyes and no one would stop him. “You know who you are,” she whispered. “You know what you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The edge of his full sensual mouth lifted, and he tucked a tendril of hair behind her ear, his fingertips lingering a moment against the back of the sensitive lobe. “It appears that you’ve tried and convicted me without giving me an opportunity to prove my innocence, because I am innocent, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v(". I am not the man you imagine me to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You deny you are Vittorio d’Severano? Head of the d’Severano family of Catania, Sicily?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course I do not deny my family or my heritage. I love my family and am responsible for my family. But how is being a d’Severano a crime?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She held his gaze. “The d’Severano family fills pages and pages of history books. Blackmail, extortion, racketeering…and those are the misdemeanors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Every family has a skeleton in the closet—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yours has at least a hundred!”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His dark eyes glittered, the brown irises flecked with gold. “Do not disparage my family. I have nothing but respect for my family. And yes, we are a very old Sicilian family. We can even trace our ancestors back a thousand years. Something I don’t think you can do, Jill Smith.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She winced at the way he said her name. He made her feel common and cheap. But wasn’t that his point? He was Vittorio d’Severano and she was no one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was right, of course. She was insignificant, and she had no one she could turn to, no one strong enough, powerful enough to protect her, because who would fight the mafia for her? Who would take on Vittorio, when not even the American and Italian government could bring him down?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But even knowing the odds, she still had to fight, because what were her options? Let Vittorio take Joe from her? Never. Not in a million years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which brought her to her senses. What was she doing in his arms, her body taut against his? It was insanity, that’s what it was, and she fought to regain control. Jillian struggled against his chest. “You forget yourself,” she gritted. “This is America, not Sicily and I do not belong to you. Let go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He released her and she took a step away, and then another, walking blindly in the downpour in the opposite direction of her house because she’d never lead Vitt there. Never in a million years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where are you going?” he called after her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Continuing with my walk. Need the exercise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll join you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he followed her anyway, although at a more leisurely pace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gut churning, mind whirling, Jillian splashed through puddles as she walked, trying to figure out how to lose Vitt, how to keep him from discovering Joe’s whereabouts.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t brought her cell phone with her, so she couldn’t call Hannah and warn her. She hadn’t brought money, either, so it wasn’t as if she could catch a cab from town.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so she just kept walking, and the rain kept coming, and Vitt continued following.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How far are you planning on going, Jill?” he asked her, as they approached an intersection and the pathway turned into a sidewalk with a four-way stoplight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Until I’m tired,” she answered, worried that the light remained red while his limousine purred just feet away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The limousine continued to the corner and made a partial turn, blocking the intersection. Blocking her access to the crosswalk. Suddenly the doors of the black limousine opened and two of Vitt’s bodyguards emerged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In any other situation she might have laughed. Who but Vitt would have bodyguards that dressed like Italian fashion models? His men wore elegant suits, exquisite leather shoes and belts, and shaded their eyes with the latest in designer stylish sunglasses. They were sophisticated and well groomed and didn’t blend in. They had never blended in. But Vittorio had to know that. Vittorio Marcello d’Severano left nothing to chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bodyguards watched her with professional interest. They were clearly waiting for a signal from Vitt, a signal he had yet to give.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell them to move,” Jillian said, turning to look at Vitt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I just told them to stop there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, but I can’t cross the street with them blocking the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. But we can’t just walk all day. We have things we have to discuss. Decisions that must be made.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Such as?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How we’re going to manage joint custody of our son—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re not. He’s mine.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And which country he’ll attend school in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The States. He’s American.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As well as Sicilian,” Vitt countered softly. “As well as half mine. You can not legally keep him from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nor can you legally take him from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Which I wouldn’t do.” He patted his chest. “Fortunately, I have excellent legal counsel, and have spent the past few months working with the best American and Sicilian attorneys. Everything’s been handled. I’ve taken care of the paperwork. The documentation is here. You’ve had him the first eleven months of his life. I’m entitled to the next.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded. “We’re to share him equally, or, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v(", darling, you risk losing him completely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll be found an unfit mother should you try to run off with him again. And you don’t want to be found in contempt of the court. It would seriously damage your chances of ever getting custody back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian stared at Vitt in horror. “You’re making that up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d never lie to you. And I never have. If we step into the car, I’ll show you the paperwork where it’s dry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made it sound so simple. Just step into his car…just look at the papers…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He must think she’d forgotten just how powerful he was. He must think she didn’t remember how seductive and attractive she’d found him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If she took that one small step, climbed into his car, she feared she’d never be safe—or sane—again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Jillian swallowed hard, her senses already overloaded. Tall and broad-shouldered, Vitt was undeniably attractive, but twenty months ago she’d fallen for more than his body. She’d loved his mind. He was brilliant. Probably the most ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("intelligent man she’d ever met and she’d enjoyed talking to him more than she’d enjoyed talking to anyone.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vitt could discuss politics and economics, history and culture, arts and sciences. He’d traveled extensively and obviously had loads of money, but he’d played no games. He’d been warm, sensual—and except for the odd strange phone call, and the sudden secret meetings—he’d been totally available.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And like a love-starved puppy, she’d lapped it all up, soaking it in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing him again reminded her of just how much she’d liked him and wanted him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing him again made her realize she’d never be immune to him. “I don’t trust you,” she said, her voice husky with emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The problem in a nutshell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t mock me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not. But your lack of trust has created terrible problems for both of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked away, bit her lip hard, so hard it drew blood. “I want to see the paperwork, but I won’t get into your car,” she said steeling herself, suppressing all emotion. “Don’t try to make me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vittorio was still walking toward her and he slid his hands into his black coat’s pockets. “I didn’t want it this way, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v(". I didn’t want it hard on you.” He was just a foot away now and she scrambled to the side. He moved past her, heading to the open limousine door. “But if you insist,” he added with an eloquent shrug, “then so be it. We’ll do it this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vittorio ducked his head and slid into the backseat of the car with its tinted windows. Jillian watched as one of the bodyguards climbed into the car and then the other. Vitt’s men weren’t coming for her after all. They were going to leave her alone.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She should have felt relief. Instead she felt fear and dread claw at her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something was wrong, very, very wrong, because Vittorio would never give up, which meant, if he was leaving her here, and letting her go, he’d already won.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had Joe. He’d found her son.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stomach heaving, she rushed toward the car, throwing herself at the door to prevent it from closing. “What have you done?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vitt looked at her from the interior of the car. The car’s yellow-white light cast hard shadows on his face, making his eyes look almost black and his expression fierce. “It’s what you wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What I want is for my son, my baby, to be with me. That’s what I want—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, you had that opportunity and you turned it down. You said you wanted to be left alone. I am leaving you…alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian didn’t remember moving or launching herself at him, but suddenly she was in the car and the limousine was moving and she was sitting on the black leather seat, next to Vittorio with his two thugs on the seat across from theirs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Calm yourself,” Vittorio repeated. “Joseph is fine. He’s in my safekeeping and with the court’s permission, will be flying to Paterno with me tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jillian’s stomach rose and fell and panicked, she searched Vitt’s eyes for the truth. “You’re bluffing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cara")]), _vm._v(", I’m not bluffing. We had an early lunch together, Joseph and I. He’s a delightful little boy, full of charm and intelligence, although I wouldn’t put him in yellow again. It doesn’t suit him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment she couldn’t breathe. Nor could she think. Everything within her froze, and died a little bit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("She’d dressed Joe in a golden-yellow T-shirt this morning and tiny adorable blue jeans. She’d thought he looked like ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("sunshine and it’d made her smile and kiss his neck where he smelled so sweet. “What have you done with him?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Besides treat him to a healthy lunch and ask that he be put down for a nap? Nothing. Should I have?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Vittorio.” Her voice was hoarse, anguished. “This isn’t a game.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve made it one, Jillian. You’ve only yourself to blame.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about Hannah?” she asked, referring to her wonderful new sitter, a sitter she’d found two months ago just after she’d rented the house. “Is she with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She is, but you don’t need her anymore. We’ll get a proper nanny in Sicily, someone who will help teach Joseph his native language.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I like Hannah—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As do I. She’s been a very good employee. Has done everything I’ve asked of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A cold, sick sensation rushed through her, making her want to throw up. With a trembling hand Jillian wiped the rain from her eyes. “What do you mean, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you’ve")]), _vm._v(" asked of her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vittorio’s mouth curved, which only made his handsome face look harder, fiercer. “She worked for me. But of course you weren’t to know that.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37083391","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459209169_ch01.vue
// module id = 75
// module chunks = 0